import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/utils/cn';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded border font-medium tracking-wide whitespace-nowrap shrink-0 focus:outline-hidden focus:ring-2 focus:ring-primary-500/30 focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'bg-neutral-100 text-neutral-700 border-neutral-150',
        brand: 'bg-primary-50 text-primary-700 border-primary-100',
        success: 'bg-emerald-50 text-emerald-700 border-emerald-100',
        warning: 'bg-amber-50 text-amber-700 border-amber-100',
        destructive: 'bg-red-50 text-red-700 border-red-100',
        danger: 'bg-red-50 text-red-700 border-red-100',
        outline: 'bg-white text-neutral-700 border-neutral-200',
        solid: 'bg-neutral-800 text-white border-neutral-800',
        solidBrand: 'bg-primary-600 text-white border-primary-600',
      },
      size: {
        sm: 'h-4 px-1.5 text-[10px]',
        md: 'h-5 px-2 text-[11px]',
        lg: 'h-6 px-2.5 text-xs',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant, size }), className)} {...props} />;
}

export { Badge, badgeVariants };
